<template>
<div class="userAssets">
    <div v-if="!datas.isDiy">
        <div class="userMoreInfo" v-if='user&&user.memberId' v-bind:style="{backgroundImage:'url(' + bgPic + ')',backgroundColor:bgColor}">
            <div class="infoAbout" v-if="isOpenPromotionValue=='T'&&currentCard.isPoint!=='F'">
                <p class="desc">{{rechargeWithOutTrans}}</p>
                <p class="descName">晋升值</p>
            </div>
            <div class="infoAbout" @click='goMemberCard' v-if="currentCard.isAccount=='T'&&isHiddenChuzhiCard=='F'">
                <p class="desc">{{accountBalance|money}}</p>
                <p class="descName">{{chuzhiCardReplace}}</p>
            </div>
            <div class="infoAbout" @click='goDiscountList' v-if="isHiddenCoupon !=='T'">
                <p class="desc">{{user&&user.couponNum}}</p>
                <p class="descName">优惠券</p>
            </div>
            <div class="infoAbout" @click='goListPoint' v-if="currentCard.isPoint!=='F'">
                <p class="desc">{{point}}</p>
                <p class="descName">{{creditName}}</p>
            </div>
            <div class="infoAbout" @click='goCardBag' v-if="isOpenCardBag=='T'">
                <p class="desc">{{cardBag}}</p>
                <p class="descName">{{cardBagName}}</p>
            </div>
        </div>
        <div class="userMoreInfo" v-else v-bind:style="{backgroundImage:'url(' + bgPic + ')',backgroundColor:bgColor}">
            <div class="infoAbout" v-if="isOpenPromotionValue=='T'">
                <p class="desc">0</p>
                <p class="descName">晋升值</p>
            </div>
            <div class="infoAbout" @click='goMemberCard' v-if="isHiddenChuzhiCard=='F'">
                <p class="desc">0</p>
                <p class="descName">{{chuzhiCardReplace}}</p>
            </div>
            <div class="infoAbout" @click='goDiscountList' v-if="isHiddenCoupon !=='T'">
                <p class="desc">0</p>
                <p class="descName">优惠券</p>
            </div>
            <div class="infoAbout" @click='goListPoint' v-if="currentCard.isPoint!=='F'">
                <p class="desc">0</p>
                <p class="descName">{{creditName}}</p>
            </div>
            <div class="infoAbout" @click='goCardBag' v-if="isOpenCardBag=='T'">
                <p class="desc">0</p>
                <p class="descName">{{cardBagName}}</p>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="userMoreInfo" v-if='user&&user.memberId' v-bind:style="{backgroundImage:'url(' + bgPic + ')',backgroundColor:bgColor}">
            <div class="infoAbout" v-for="(diy,diyIndex) in diyList" :key="diyIndex" @click="goDiyUrl(diy)">
                <p class="desc">{{diy.num}}</p>
                <p class="descName">{{diy.name}}</p>
            </div>
        </div>
        <div class="userMoreInfo" v-else v-bind:style="{backgroundImage:'url(' + bgPic + ')',backgroundColor:bgColor}">
            <div class="infoAbout" v-for="(diy,diyIndex) in datas.diyList" :key="diyIndex">
                <p class="desc">0</p>
                <p class="descName">{{diy.name}}</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from "moment";
import api from "@/utils/api";
import {
    jAlert3
} from "@/base/jAlert/jAlert";
import {
    urlEncode,
    addNum
} from "@/utils/index";
import {
    setStorage,
    getStorage
} from "@/utils/wxuser";

var config = {};
export default {
    data() {
        return {
            wxuser: getStorage("wxuser"),
            user: getStorage("user"),
            creditName: getStorage("creditName") || "积分",
            chuzhiCardReplace: getStorage("chuzhiCardReplace") || "储值卡",
            currentCardIndex: 0,
            currentCard: {},
            cardBagName: getStorage("cardBagName") || "卡包",
            isOpenCardBag: getStorage("isOpenCardBag") || "F",
            isHiddenChuzhiCard: getStorage("isHiddenChuzhiCard") || "F",
            isOpenRightsCoupon: getStorage("isOpenRightsCoupon") || "F",
            isOpenPromotionValue: getStorage("isOpenPromotionValue") || "F",
            isHiddenCoupon: getStorage("isHiddenCoupon") || "F",
            rechargeWithOutTrans: 0,
            cardBag: 0,
            fromHotelGroupPoint: 0
        };
    },
    props: ["datas"],
    components: {},
    methods: {
        goDiyUrl(item) {
            if (item.code == "gift") {
                jAlert3("敬请期待~");
                return;
            }
            if (item.link) {
                this.goUrl(item.link);
            }
        },
        queryCardPointBalanceWithUnionGroup() {
            api
                .queryCardPointBalanceWithUnionGroup({
                    hotelGroupCode: config.hotelGroupCode,
                    cardNo: this.currentCard.cardNo,
                    channel: "wechat",
                })
                .then((res) => {
                    if (res.result == 1 && res.retVal.result == 0) {
                        this.fromHotelGroupPoint = res.retVal.retVal;
                    }
                });
        },
        listMemberPoint() {
            api
                .listMemberPoint({
                    memberId: this.user.memberId,
                    hotelGroupCode: config.hotelGroupCode,
                    hotelGroupId: config.hotelGroupId,
                    hotelCode: config.hotelCode,
                })
                .then((res) => {
                    if (res.result == 1 && res.retVal.resultCode == 0) {
                        if (res.retVal.result && res.retVal.result.rechargeWithOutTrans) {
                            this.rechargeWithOutTrans =
                                res.retVal.result.rechargeWithOutTrans;
                        }
                    }
                });
        },
        isMemberLogin(){
            if (!(this.user && this.user.memberId)) {
               this.toLogin()
            } else {
                return true;
            }
        },
        goCardBag() {
            if (!this.isMemberLogin()) {
                return false;
            }
            window.location.href = "/wechat/?/#/memberCardList"
           
        },
        goDiscountList() {
            if (!this.isMemberLogin()) {
                return false;
            }
             window.location.href = "/wechat/?/#/discountList"
          
        },
        goMemberCard() {
            if (!this.isMemberLogin()) {
                return false;
            }
             window.location.href = "/wechat/?/#/memberCard"
           
        },
        goListPoint() {
            if (!this.isMemberLogin()) {
                return false;
            }
             window.location.href = "/wechat/?/#/memberListPoint"
           
        },
        getCardList() {
            api
                .getCardList({
                    hotelGroupId: config.hotelGroupId,
                    openid: this.wxuser.openid,
                    appid: config.appid,
                    componentAppid: config.componentAppid,
                    hotelCode: config.hotelCode,
                    hotelGroupCode: config.hotelGroupCode,
                    memberId: this.user.memberId,
                    isGroupCard: "F",
                })
                .then((res) => {
                    if (res.result == 1) {
                        if (res.retVal.cardListDto.length > 0) {
                            this.cardBag = res.retVal.cardListDto.length;
                        }
                    }
                });
        },
        adjustDom() {
            var userMoreInfo = document.querySelector(".userMoreInfo");
            var childList = userMoreInfo.children;
            if (childList.length == 0) {
                userMoreInfo.style.display = "none";
            }
            /* if(childList.length>3){
              userMoreInfo.classList.add("more");
              let notAddBorderList = [];
              if(childList.length%3 == 0){
                notAddBorderList = [childList.length-3,childList.length-2,childList.length-1];
              }
              if(childList.length%3 == 2){
                notAddBorderList = [childList.length-2,childList.length-1];
              }
              if(childList.length%3 == 1){
                notAddBorderList = [childList.length-1];
              }
              Array.from(childList).forEach((n,i)=>{
                if(notAddBorderList.indexOf(i) == -1){
                  n.classList.add("borderBottom");
                }else{
                  n.classList.remove("borderBottom");
                }
              })
            }else{
              userMoreInfo.classList.remove("more");
            } */
        },
    },

    created() {
        config = getStorage("config");
    },
    mounted() {
        if (this.user && this.user.memberId) {
            [this.currentCard, this.currentCardIndex] = this.getCurrentCard();
            /* setTimeout(() => {
              if (this.user && this.currentCard && this.currentCard.accountBalance) {
                this.accountBalance = this.currentCard.accountBalance;
              }
              if (
                this.user &&
                this.currentCard &&
                this.currentCard.accountTreatBalance
              ) {
                this.accountBalance = addNum(
                  Number(this.accountBalance),
                  Number(this.currentCard.accountTreatBalance)
                );
              }
            }, 0); */
            if (getStorage("crossGroupPointExchange")) {
                this.queryCardPointBalanceWithUnionGroup();
            }
            if (this.isOpenPromotionValue == "T") {
                this.listMemberPoint();
            }
            if (this.isOpenCardBag == "T") {
                this.getCardList();
            }
        }
        this.$nextTick(() => {
            this.adjustDom();
        });
    },
    beforeDestroy() {},
    computed: {
        accountBalance() {
            let accountBalance = 0;
            if (this.user && this.user.memberId) {
                [this.currentCard, this.currentCardIndex] = this.getCurrentCard();
                if (this.user && this.currentCard && this.currentCard.accountBalance) {
                    accountBalance = this.currentCard.accountBalance;
                }
            }
            if (
                this.user &&
                this.currentCard &&
                this.currentCard.accountTreatBalance
            ) {
                accountBalance = addNum(
                    Number(accountBalance),
                    Number(this.currentCard.accountTreatBalance)
                );
            }
            return accountBalance
        },
        bgPic() {
            let bgPic = ``;
            if (this.datas && this.datas.bgType == "pic") {
                bgPic = this.datas.bgPic;
            }
            return bgPic;
        },
        bgColor() {
            let bgColor = ``;
            if (this.datas && this.datas.bgType == "color") {
                bgColor = this.datas.bgColor;
            }
            return bgColor;
        },
        point() {
            var num = Number(this.currentCard.pointBalance) + this.fromHotelGroupPoint;
            if (isNaN(num)) {
                return 0;
            }
            if (num - parseInt(num) == 0) {
                return parseInt(num)
            } else {
                return num.toFixed(2)
            }
        },
        diyList() {
            let diyList = [];
            if (this.datas && this.datas.isDiy && this.user && this.user.memberId) {
                if (this.datas.diyList && this.datas.diyList.length > 0) {
                    this.datas.diyList.forEach((n) => {
                        n.num = 0;
                        n.canAdd = true;
                        if (n.code == "gift") {
                            n.num = 0;
                        }
                        if (n.code == "coupon") {
                            n.num = this.user && this.user.couponNum;
                        }
                        if (n.code == "chuzhi") {
                            n.num = this.accountBalance;
                            if (!this.currentCard.isAccount == "T") {
                                n.canAdd = false;
                            }
                        }
                        if (n.code == "point") {
                            n.num = this.point;
                            if (this.currentCard.isPoint == "F") {
                                n.canAdd = false;
                            }
                        }
                        if (n.code == "cardBag") {
                            n.num = this.cardBag;
                        }
                        if (n.canAdd) {
                            diyList.push(n);
                        }
                    });
                }
            }
            return diyList;
        },
    },
    watch: {},
};
</script>

<style lang="less">
@import url("~@/styles/base.less");
@import url("~@/styles/skin.less");
@import url("~@/styles/mixin.less");

.userAssets {
    margin-bottom: 15px;

    .userMoreInfo {
        min-height: 80px;
        width: calc(~"100vw - 30px");
        margin: 0 auto;
        background: #ffffff;
        box-shadow: 0px 2px 10px -3px rgba(0, 0, 0, 0.11);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-size: 100% 100%;

        &.more {
            flex-wrap: wrap;
            justify-content: flex-start;
            padding: 0 15px;

            .infoAbout {
                flex: 0 0 33%;

                &.borderBottom {
                    border-bottom: 1px solid rgba(238, 238, 238, 1);
                }
            }
        }

        .infoAbout {
            flex: 1;
            display: flex;
            flex-direction: column;
            height: 80px;
            align-items: center;
            justify-content: center;

            .desc {
                font-size: 20px;
                color: #333333;
                font-weight: bold;
            }

            .descName {
                font-size: 12px;
                color: #999999;
                margin-top: 8px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/userAssets.vue